import {
  ADD_FILTER,
  ADD_MULTI_SELECT,
  TOGGLE_SLIDE_LEAVE,
  TOGGLE_SLIDE_STATUS,
  EXPLORE_OPTION,
} from '../constants/action-types';

export function updateResult(payload) {
  return { type: ADD_FILTER, payload };
}

export function updateMultiSelect(payload) {
  return { type: ADD_MULTI_SELECT, payload };
}

export function toggleSlideLeave() {
  return { type: TOGGLE_SLIDE_LEAVE };
}

export function exploreToggle() {
  return { type: EXPLORE_OPTION };
}

export function toggleSlideStatus(payload) {
  return { type: TOGGLE_SLIDE_STATUS, payload };
}
